module.exports = __webpack_public_path__ + "static/img/chart-subscription.c54e53e5.svg";